export default __webpack_public_path__ + "static/media/waterlevel.80fe1f75.webp";